import * as React from 'react';
import { observer } from 'mobx-react';
import aptusLogo from "Assets/images/aptus-logo-full-colour.png";

@observer
export default class LoginWrap extends React.Component {

	public render() {
		return (
			<div className="login-registration-content">
				<div className="info-section">
					<div className="info-header">
						<img className="header-icon" alt="Aptus logo" src={aptusLogo}/>
						<div className="header-separator"/>
						<div className="header-description">
							Ordering tool
						</div>
					</div>
					<div className="info-body">
						<h1 className="info-body-title">Order your Aptus parts online</h1>
						<div className="info-body-subtitle">Order, track and review your Aptus project.</div>
					</div>
					<div className="spacing-div"/>
					<div className="background-wrap"/>
				</div>
				<div className="form-section">
					{this.props.children}
				</div>
			</div>
		);
	}
}